import { render } from "./InteractiveTablePage.vue?vue&type=template&id=6e05a6b6&scoped=true"
import script from "./InteractiveTablePage.vue?vue&type=script&lang=js"
export * from "./InteractiveTablePage.vue?vue&type=script&lang=js"

import "./InteractiveTablePage.vue?vue&type=style&index=0&id=6e05a6b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e05a6b6"]])

export default __exports__